import { v4 as uuid } from 'uuid';

import {
    apiGetPublisherDetails,
    apiUpdatePublisherDetails,
} from './api';

export async function getPublisherDetails ({ token, withCoverPhoto } = {}) {
    this.env.errorStore.action = 'getPublisherDetails';
    const resolvedToken = token || this.env.userStore.publisher?.token;

    const res = await apiGetPublisherDetails({
        token: resolvedToken,
        traceId: this.env.traceId,
        withCoverPhoto,
    });

    if (res.data && res.data.data && res.data.data.getPublishers) {
        const edges = res.data.data.getPublishers.edges;
        if (edges && edges.length > 0) {
            this.publisherDetails = edges[0].node;
            this.observed.publisherDetails = uuid();
        }
    }
}

export async function updatePublisherDetails ({ publicAccess, coverPhoto }) {
    this.env.errorStore.action = 'updatePublisherDetails';
    const publisher = this.env.userStore.publisher;

    const res = await apiUpdatePublisherDetails({
        publicAccess,
        coverPhoto,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.updatePublisherDetails) {
        const edges = res.data.data.updatePublisherDetails.edges;
        if (edges && edges.length > 0) {
            this.publisherDetails = edges[0].node;
            this.observed.publisherDetails = uuid();
        }
    }
}

export async function uploadCoverPhoto ({ file, assetType }) {
    this.env.errorStore.action = 'uploadCoverPhoto';
    const res = await this.env.userStore.uploadAssets({
        file,
        assetType,
    });
    this.assets[assetType] = res.data.data;
    this.observed.assets = {
        ...this.observed.assets,
        [assetType]: uuid(),
    };
}
